import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart } from './MetaPixel';
import { ShoppingCart, ChevronDown, Trophy, Package } from 'lucide-react';
export function PricingSection() {
  const [expandedPlan, setExpandedPlan] = useState<'premium' | 'basico' | null>('premium');
  const handleCheckout = (url: string) => {
    trackAddToCart();
    window.location.href = url;
  };
  const togglePlan = (plan: 'premium' | 'basico') => {
    setExpandedPlan(expandedPlan === plan ? null : plan);
  };
  return <section id="pricing" className="py-16 px-4 bg-gray-950 text-white scroll-mt-10" data-id="element-104">
      <div className="max-w-lg mx-auto" data-id="element-105">
        <div className="text-center mb-8" data-id="element-106">
          <div className="flex justify-center mb-3" data-id="element-107">
            <ShoppingCart className="w-8 h-8 text-yellow-400" data-id="element-108" />
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase" data-id="element-109">
            ELEGÍ TU PLAN
            <br data-id="element-110" />Y EMPEZÁ HOY
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-111">
            Descarga inmediata. Acceso de por vida.
          </p>
          <p className="text-yellow-400 font-bold text-sm mt-2" data-id="element-112">
            👇 Elegí tu plan y dale a COMPRAR AHORA
          </p>
        </div>

        <div className="space-y-3 mb-6" data-id="element-113">
          {/* Plan Básico */}
          <div className={`rounded-xl border-2 transition-all duration-300 overflow-hidden ${expandedPlan === 'basico' ? 'border-gray-400 bg-gray-900' : 'border-gray-700 bg-gray-900/50'}`} data-id="element-114">
            <button onClick={() => togglePlan('basico')} className="w-full flex items-center justify-between p-4 text-left" data-id="element-115">
              <div className="flex items-center gap-3" data-id="element-116">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${expandedPlan === 'basico' ? 'border-white bg-white' : 'border-gray-500'}`} data-id="element-117">
                  {expandedPlan === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-gray-900" data-id="element-118" />}
                </div>
                <Package className="w-5 h-5 text-gray-400" data-id="element-119" />
                <div data-id="element-120">
                  <span className="font-black text-base text-white" data-id="element-121">
                    PACK BÁSICO
                  </span>
                  <p className="text-xs text-gray-400 mt-0.5" data-id="element-122">
                    6 tomos + 6 bonos
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-123">
                <div className="text-right" data-id="element-124">
                  <span className="text-xs text-gray-500 line-through block" data-id="element-125">
                    $39.990
                  </span>
                  <span className="font-black text-xl text-white" data-id="element-126">$19.990</span>
                </div>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${expandedPlan === 'basico' ? 'rotate-180' : ''}`} data-id="element-127" />
              </div>
            </button>

            <AnimatePresence data-id="element-128">
              {expandedPlan === 'basico' && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-129">
                  <div className="px-4 pb-4 space-y-2" data-id="element-130">
                    <div className="flex items-center gap-2 text-sm text-gray-300" data-id="element-131">
                      <span className="text-green-400" data-id="element-132">✅</span> 6 tomos
                      completos
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-300" data-id="element-133">
                      <span className="text-green-400" data-id="element-134">✅</span> 6 bonos
                      exclusivos
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>

          {/* Plan Premium */}
          <div className={`rounded-xl border-2 transition-all duration-300 overflow-hidden relative ${expandedPlan === 'premium' ? 'border-yellow-400 bg-gray-900 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'border-yellow-400/50 bg-gray-900/50'}`} data-id="element-135">
            <button onClick={() => togglePlan('premium')} className="w-full flex items-center justify-between p-4 text-left" data-id="element-136">
              <div className="flex items-center gap-3" data-id="element-137">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${expandedPlan === 'premium' ? 'border-yellow-400 bg-yellow-400' : 'border-yellow-400/50'}`} data-id="element-138">
                  {expandedPlan === 'premium' && <div className="w-2.5 h-2.5 rounded-full bg-gray-900" data-id="element-139" />}
                </div>
                <Trophy className="w-5 h-5 text-yellow-400" data-id="element-140" />
                <div data-id="element-141">
                  <span className="font-black text-base text-white" data-id="element-142">
                    PACK COMPLETO
                  </span>
                  <div className="flex gap-1.5 mt-1" data-id="element-143">
                    <span className="text-[10px] font-bold bg-yellow-400 text-black px-1.5 py-0.5 rounded uppercase" data-id="element-144">
                      Más elegido
                    </span>
                    <span className="text-[10px] font-bold bg-green-500 text-white px-1.5 py-0.5 rounded uppercase" data-id="element-145">
                      Mejor valor
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-146">
                <div className="text-right" data-id="element-147">
                  <span className="text-xs text-gray-500 line-through block" data-id="element-148">
                    $59.990
                  </span>
                  <span className="font-black text-2xl text-yellow-400" data-id="element-149">
                    $29.990
                  </span>
                </div>
                <ChevronDown className={`w-5 h-5 text-yellow-400 transition-transform duration-300 ${expandedPlan === 'premium' ? 'rotate-180' : ''}`} data-id="element-150" />
              </div>
            </button>

            <AnimatePresence data-id="element-151">
              {expandedPlan === 'premium' && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-152">
                  <div className="px-4 pb-4 space-y-2" data-id="element-153">
                    <div className="flex items-center gap-2 text-sm text-gray-300" data-id="element-154">
                      <span className="text-green-400" data-id="element-155">✅</span> 6 tomos
                      completos
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-300" data-id="element-156">
                      <span className="text-green-400" data-id="element-157">✅</span> 6 bonos
                      exclusivos
                    </div>
                    <div className="flex items-center gap-2 text-sm text-yellow-300 font-semibold" data-id="element-158">
                      <span data-id="element-159">🔥</span> Pack premium de recetas avanzadas
                    </div>
                    <div className="flex items-center gap-2 text-sm text-yellow-300 font-semibold" data-id="element-160">
                      <span data-id="element-161">🔥</span> Guía para mantener resultados y evitar el
                      efecto rebote
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>
        </div>

        {/* Social proof line */}
        <div className="text-center mb-5" data-id="element-162">
          <p className="text-xs text-gray-400" data-id="element-163">
            <span className="text-yellow-400" data-id="element-164">⭐</span> El 80% de nuestros
            clientes elige el Pack Completo.
            <br data-id="element-165" />
            Es el que más valor tiene por su precio.
          </p>
        </div>

        {/* Single buy button */}
        <button onClick={() => {
        const url = expandedPlan === 'basico' ? 'https://checkout.tiendadigitalonline.com/cart/47989981282545:1' : 'https://checkout.tiendadigitalonline.com/cart/47989996486897:1';
        handleCheckout(url);
      }} className="w-full bg-gradient-to-b from-yellow-400 to-yellow-500 hover:from-yellow-300 hover:to-yellow-400 text-black font-black text-lg py-4 rounded-xl shadow-lg transition-all uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-166">
          <ShoppingCart className="w-5 h-5" data-id="element-167" />
          COMPRAR AHORA
        </button>
        <p className="text-center text-xs text-gray-500 font-medium mt-3" data-id="element-168">
          Descarga inmediata • Garantía de 7 días
        </p>
      </div>
    </section>;
}